export const MATCH_POSTAL_CODE = /^\d+$/;
